activateLink = (haysack, needle) => {
  window.location.pathname;
  haysack.forEach((el) => {
    navUrl = document.createElement('a');
    navUrl.href = el.href;
    if (navUrl.pathname == needle) {
      el.classList.add('active');
    }
  })
}

submit_closest_form = (element) => {
  if (element.value !== "" && (element.id == 'owner' || (new Date(element.value)).getFullYear() > 2000)) {
    const form = element.closest('form');
    if (form) form.requestSubmit();
  }
}

disable_wheel_scrool_on_input_type_numer = () => {
  document.querySelectorAll('form input[type=number]').forEach( e =>
    e.addEventListener('wheel', e => {
      e.target.blur();
    })
  )
}

document.addEventListener("click", (event) => {
  const cell = event.target.closest("td.clickable")
  if (!cell) return

  const column = event.target.cellIndex ?? event.target.parentElement?.cellIndex
  if (column === 8) return

  window.location = cell.dataset.href
})

document.addEventListener("change", (event) => {
  if (event.target && event.target.id === "accommodation_id") {
    event.preventDefault()
    const form = event.target.closest("form")
    if (form) form.requestSubmit()
  }
})

document.addEventListener("turbo:load", function() {
  disable_wheel_scrool_on_input_type_numer()
  url = window.location.pathname;
  activateLink(document.querySelectorAll('.navbar ul li a.nav-link:not(#navbarDropdownMenuLink)'), url)
  activateLink(document.querySelectorAll('#reports.nav a'), url)
  document.querySelectorAll("#owner, #since, #until").forEach((element) => {
    element.addEventListener("change", function(e) {
      e.preventDefault();
      submit_closest_form(this)
    });
  });
});
